// extracted by mini-css-extract-plugin
export var sections = "layout-module--sections--1NoKs";
export var container = "layout-module--container--YM7Lx";
export var pages = "layout-module--pages--659VS";
export var title = "layout-module--title--3Tmt6";
export var heading = "layout-module--heading--2By-2";
export var navLinks = "layout-module--nav-links--1VlO2";
export var navLinkItem = "layout-module--nav-link-item--31U8T";
export var navLinkText = "layout-module--nav-link-text--ExV28";